import React from 'react';
import audioPlayImg from '../../../packages/content/assets/audioPlay.png';
import audioPauseImg from '../../../packages/content/assets/audioPause.png';

interface TinyAudioPlayerProps {
  url: string;
  width?: string | number;
  height?: string | number;
}

interface TinyAudioPlayerState {
  isPlaying: boolean;
}

export class TinyAudioPlayer extends React.Component<
  TinyAudioPlayerProps,
  TinyAudioPlayerState
> {
  public static audios: any = {};
  private id: string;
  private audioElement = React.createRef<HTMLAudioElement>();

  constructor(props: TinyAudioPlayerProps) {
    super(props);
    this.state = {
      isPlaying: false,
    };
    this.id = Math.random()
      .toString(36)
      .substring(4);
    TinyAudioPlayer.audios[this.id] = this;
  }

  public onended = () => {
    this.setState({
      isPlaying: false,
    });
  }

  public componentDidMount() {
    this.audioElement.current.addEventListener('ended', this.onended);
  }

  public componentWillUnmount() {
    delete TinyAudioPlayer.audios[this.id];
    this.audioElement.current.pause();
    this.audioElement.current.removeEventListener('ended', this.onended);
  }

  public togglePlaying = (e: any) => {
    e.stopPropagation();
    if (this.state.isPlaying) {
      this.audioElement.current.pause();
    } else {
      const ids = Object.keys(TinyAudioPlayer.audios);
      for (const id of ids) {
        const otherAudio = TinyAudioPlayer.audios[id];
        if (otherAudio && otherAudio.id !== this.id) {
          otherAudio.setState({
            isPlaying: false,
          });
          if (otherAudio.audioElement.current) {
            otherAudio.audioElement.current.pause();
          }
        }
      }
      this.audioElement.current.play();
    }
    this.setState({
      isPlaying: !this.state.isPlaying,
    });
  }

  public render() {
    const { url, width, height } = this.props;
    return (
      <React.Fragment>
        {url && (
          <audio
            ref={this.audioElement}
            style={{ display: 'none' }}
            src={url}
          />
        )}
        {url && (
          <img
            src={this.state.isPlaying ? audioPauseImg : audioPlayImg}
            onClick={this.togglePlaying}
            style={{
              cursor: 'pointer',
              width: width || 50,
              height: height || 50,
            }}
            alt={'audio image'}
          />
        )}
      </React.Fragment>
    );
  }
}
